module.exports = __webpack_public_path__ + "img/EN-MA-HMI-3.40be3b59.png";